import {
  NEWDANHMUCNHACUNGCAP_COUNT_ASSIGN_SUCCESS,
  NEWDANHMUCNHACUNGCAP_HISTORY_LIST_SUCCESS,
  NEWDANHMUCNHACUNGCAP_IMPORT_SUCCESS,
  NEWDANHMUCNHACUNGCAP_LIST_SUCCESS,
  NEWDANHMUCNHACUNGCAP_NEW_CARE_SUCCESS,
  NEWDANHMUCNHACUNGCAP_ONE_SUCCESS,
  NEWDANHMUCNHACUNGCAP_UPDATE_FILTER,
  NEWDANHMUCNHACUNGCAP_SAVE_SUCCESS,
  NEWDANHMUCNHACUNGCAP_UPDATE_HOMEPAGE_FILTER,
  NEWDANHMUCNHACUNGCAP_HOMEPAGE_LIST_SUCCESS,
  NEWDANHMUCNHACUNGCAP_HOMEPAGE_ONE_SUCCESS,
  NEWDANHMUCNHACUNGCAP_HANDLE_IMPORT_ERRORS,
} from 'src/actions/newdanhmucnhacungcap.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

const initState = {
  filter: {
    so_dien_thoai: '',
    loai_sim: {},
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  homepageNewdanhmucnhacungcapFilter: {
    so_dien_thoai: '',
    loai_sim: {},
    homepageNewdanhmucnhacungcapPage: 0,
    homepageNewdanhmucnhacungcapLimit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  selected: undefined,
  homepageNewdanhmucnhacungcapItems: [],
  homepageNewdanhmucnhacungcapTotal: 0,
  homepageNewdanhmucnhacungcapSelected: undefined,
  temp: [],
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0,
  temp_upgoicuoc: [],
  errorRows: {},
}

const newdanhmucnhacungcapReducer = (state = initState, action) => {
  switch (action.type) {
    case NEWDANHMUCNHACUNGCAP_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case NEWDANHMUCNHACUNGCAP_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case NEWDANHMUCNHACUNGCAP_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case NEWDANHMUCNHACUNGCAP_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageNewdanhmucnhacungcapFilter !== 'undefined' && state.homepageNewdanhmucnhacungcapFilter) {
        if (action.data.homepageNewdanhmucnhacungcapPage == 'no_update' && typeof state.homepageNewdanhmucnhacungcapFilter.homepageNewdanhmucnhacungcapPage !== 'undefined') action.data.homepageNewdanhmucnhacungcapPage = state.homepageNewdanhmucnhacungcapFilter.homepageNewdanhmucnhacungcapPage;
        if (action.data.homepageNewdanhmucnhacungcapLimit == 'no_update' && typeof state.homepageNewdanhmucnhacungcapFilter.homepageNewdanhmucnhacungcapLimit !== 'undefined') action.data.homepageNewdanhmucnhacungcapLimit = state.homepageNewdanhmucnhacungcapFilter.homepageNewdanhmucnhacungcapLimit;
      }
      return {
        ...state,
        homepageNewdanhmucnhacungcapFilter: action.data,
      }
    }
    case NEWDANHMUCNHACUNGCAP_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageNewdanhmucnhacungcapItems: action.data.homepageNewdanhmucnhacungcapItems,
        homepageNewdanhmucnhacungcapTotal: action.data.homepageNewdanhmucnhacungcapTotal,
      }
    }
    case NEWDANHMUCNHACUNGCAP_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageNewdanhmucnhacungcapSelected: action.data
      }
    }
    case NEWDANHMUCNHACUNGCAP_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case NEWDANHMUCNHACUNGCAP_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case NEWDANHMUCNHACUNGCAP_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case NEWDANHMUCNHACUNGCAP_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    case NEWDANHMUCNHACUNGCAP_SAVE_SUCCESS: {
      return {
        ...state,
        temp_upgoicuoc: []
      }
    }
    case NEWDANHMUCNHACUNGCAP_HANDLE_IMPORT_ERRORS: {
      return {
        ...state,
        errorRows: action.data,
      }
    }
    default: {
      return state;
    }
  }
}
export default newdanhmucnhacungcapReducer